"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.6 8.4h10.8V7.2H6.6v1.2zM17.4 12.6H6.6v-1.2h10.8v1.2zM17.4 16.8H6.6v-1.2h10.8v1.2z" }), "BurgerMenu");
//# sourceMappingURL=BurgerMenu.js.map